module.exports = __webpack_public_path__ + "img/Home.cd0ae204.svg";